import { FC, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { NAV_TO_VOUCHER_DETAIL, SAGA_GUARDS } from 'src/navigation'
import { shoot } from 'src/redux/actions'
import { select_error, select_history_item, select_loading, select_vouchers } from 'src/redux/store'
import { dict, voucher_t } from 'src/types'
import { render_topbar, sort_vouchers, update_counter_dict } from 'src/utils'
import { FailureModal, Loader } from 'src/widgets'

import { ListBox, OverviewBox } from './bricks'

const Community: FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  /**
   * Use Selectors
   */
  const to_voucher_number = useSelector(select_history_item('to-voucher-detail'))
  const loading = useSelector(select_loading(SAGA_GUARDS.COMMUNITY))
  const error = useSelector(select_error(SAGA_GUARDS.COMMUNITY))
  const vouchers = useSelector(select_vouchers)

  /**
   * Use State
   */
  const [filtered_vouchs, set_filtered_vouchs] = useState<voucher_t[]>()
  const [types, set_types] = useState<dict<number>>()
  const [visible_overview, set_visible_overview] = useState(true)

  /**
   * Use Effect
   */
  useEffect(() => {
    if (to_voucher_number) {
      dispatch(shoot.reduce_history_item('to-voucher-detail'))
      navigate(`${NAV_TO_VOUCHER_DETAIL}?voucher-number=${to_voucher_number}`)
    }
  }, [to_voucher_number])

  useEffect(() => {
    dispatch(shoot.saga_resolve_vouchers())
  }, [])

  useEffect(() => {
    if (vouchers) {
      init_overview()
      set_filtered_vouchs(sort_vouchers(vouchers))
    }
  }, [vouchers])

  /**
   * Support functions
   */
  const init_overview = () => {
    const types_: dict<number> = {}
    vouchers?.forEach((voc) => update_counter_dict(types_, voc?.category))
    set_types(types_)
    set_visible_overview(Object.keys(types_)?.length > 0)
  }

  const on_filter = (args: { type?: string }) => {
    set_filtered_vouchs(
      sort_vouchers(
        vouchers?.filter((voc) => {
          return args?.type === 'all-types' || voc?.category === args?.type
        }) || []
      )
    )
  }

  return (
    <Container fluid className="mb-5 pb-5 d-flex justify-content-center bg-f7f7f7">
      <Col lg={11}>
        {/* LOADER */}
        {loading && <Loader overlay={true} />}

        {/* FAILURE MODAL */}
        <FailureModal error={error} on_close={() => dispatch(shoot.reduce_error())} />

        {/* TOP-BAR */}
        {render_topbar(() => navigate(-1))}

        {/* TITLE */}
        <h1 className="font-40-freightdisp-semibold">{t('community.title')}</h1>

        {vouchers && (
          <Row className="mt-3">
            {/* OVERVIEW BOX */}
            {visible_overview && (
              <Col lg={3}>
                <OverviewBox n_voucher={vouchers?.length} types={types} on_filter={on_filter} />
              </Col>
            )}

            {/* TODO CHANGE LIST */}
            {/* VOUCHER BOX */}
            <Col lg={9} className="mt-5">
              <ListBox vouchers={filtered_vouchs} />
            </Col>
          </Row>
        )}
      </Col>
    </Container>
  )
}

export default Community
